import axios, { InternalAxiosRequestConfig } from 'axios';

// Create an axios instance with your backend URL
// For development, this will likely be localhost:5000
const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || (window.location.hostname === 'localhost' ? 'http://localhost:5000/api' : 'https://kano-fresh.onrender.com/api'),
});

// Interceptor: Automatically adds the Authorization token to every request
// This is crucial for Protected Routes (Dashboard, Admin, etc.)
API.interceptors.request.use((req: InternalAxiosRequestConfig) => {
  const userStr = localStorage.getItem('user');
  if (userStr) {
    try {
      const user = JSON.parse(userStr);
      // Assuming your backend will return a token property on login
      if (user.token) {
        req.headers.Authorization = `Bearer ${user.token}`;
      }
    } catch (error) {
      console.error("Error parsing user data from local storage:", error);
    }
  }
  return req;
});

// Define your API calls here
export const fetchProducts = () => API.get('/products');
export const fetchProductById = (id: string) => API.get(`/products/${id}`);
export const createProduct = (productData: any) => API.post('/products', productData);
export const updateProduct = (id: string, productData: any) => API.put(`/products/${id}`, productData);
export const deleteProduct = (id: string) => API.delete(`/products/${id}`);
export const createOrder = (orderData: any) => API.post('/orders', orderData);
export const fetchAllOrders = () => API.get('/orders');
export const updateOrderStatus = (id: string, status: string) => API.put(`/orders/${id}/status`, { status });
export const fetchOrder = (id: string) => API.get(`/orders/${id}`);
export const loginUser = (formData: any) => API.post('/auth/login', formData);
export const updateUserProfile = (userData: any) => API.put('/users/profile', userData);
export const fetchUserOrders = () => API.get('/orders/myorders');
export const registerUser = (formData: any) => API.post('/auth/register', formData);
export const verifyEmail = (token: string) => API.get(`/auth/verify/${token}`);
export const resendVerificationEmail = (email: string) => API.post('/auth/resend-verification', { email });
export const forgotPassword = (email: string) => API.post('/auth/forgot-password', { email });
export const changePassword = (data: any) => API.post('/users/change-password', data);
export const recordVisit = () => API.post('/analytics/visit');
export const fetchAnalytics = () => API.get('/analytics');
export const fetchAdmins = () => API.get('/admin/admins');
export const createAdmin = (data: any) => API.post('/admin/admins', data);
export const deleteAdmin = (id: string) => API.delete(`/admin/admins/${id}`);
export const fetchAuditLogs = () => API.get('/admin/logs');
export const fetchSystemBackup = () => API.get('/admin/backup');
export const submitPartnerInquiry = (data: any) => API.post('/partners', data);

// Message/Support endpoints
export const sendMessage = (data: any) => API.post('/messages', data);
export const fetchMessages = () => API.get('/messages');
export const updateMessageStatus = (id: string, status: string) => API.put(`/messages/${id}/status`, { status });
export const deleteMessage = (id: string) => API.delete(`/messages/${id}`);
export const replyToMessage = (id: string, reply: string) => API.post(`/messages/${id}/reply`, { reply });

export default API;